export default "images/git-logo.png";